import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { GenericDatasetAdapter } from 'app/model/adapters/datasets/generic-dataset.adapter';
import { DatasetRegistryService } from 'app/registries/dataset/dataset-registry.service';
import { GenericLinkedServiceAdapter } from 'app/model/adapters/linkedservices/generic-linkedservice.adapter';
import { LinkedServiceRegistryService } from 'app/registries/linked-service/linked-service-registry.service';
import { LinkedService } from 'app/model/linkedservice/linkedservice';
import { Dataset } from 'app/model/dataset/dataset';
import { IResourceBase } from 'app/shared/utils/resourcefiles.utils';
import { IResourceContext, ModelFetchUtils } from 'shell-models-lib';
import { linkedServiceReferenceWithoutParameterizationRemainer } from '../../adapters/reference-remainer';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';

export class ModelRegisterationUtils {
    public static async registerUnknownSubtype(resourceType: string, subType: string, contextData: IResourceContext): Promise<void> {
        try {
            ModelFetchUtils.getModelByResourceType(resourceType, subType);
        } catch {
            switch (resourceType.toLowerCase()) {
                case 'dataset':
                    await ModelRegisterationUtils._registerDataset(subType, contextData);
                    break;
                case 'linkedservice':
                    await ModelRegisterationUtils._registerLinkedService(subType, contextData);
                    break;
                default:
                    break;
            }
        }
    }

    public static replaceSubTypeWithActual(resource: IResourceBase): IResourceBase {
        const toReturn: IResourceBase = JSON.parse(JSON.stringify(resource));
        toReturn.subType = ModelRegisterationUtils._getActualSubType(toReturn.subType);
        return toReturn;
    }

    private static _getActualSubType(subType?: string): string | undefined {
        if (subType) {
            const splits = subType.split(ModelFetchUtils.separator);
            return splits[0];
        }
        return undefined;
    }

    private static async _registerLinkedService(subType: string, contextData: IResourceContext): Promise<void> {
        const model = Metamodel.createModel(LinkedService.MODEL, {
            name: ModelRegisterationUtils._uniqueModelName(subType, LinkedService.MODEL.name),
            abstract: false,
            display: [subType],
            tags: {
                subType,
                type: LinkedService.MODEL.name
            },
            createdFromUnknownType: true
        });

        AdapterRegistry.createAdapter({
            model,
            asynchronous: true,
            adapts: {
                name: '*',
                properties: {
                    description: '*',
                    type: '*',
                    connectVia: '*'
                }
            }
        }, GenericLinkedServiceAdapter);
        const linkedServiceRegistryService = await getServiceInstance<LinkedServiceRegistryService>(contextData, 'LinkedServiceRegistryService');

        linkedServiceRegistryService.register({
            type: model.name,
            displayName: model.display.length > 0 ? model.display[0] : subType,
            notShowInTypeSelection: true, // unknown type shouldn't support create for security reason
            icon: {
                className: 'svg-i-20x20-linkedservice'
            },
            copySinkTypes: [],
            copySourceTypes: [],
            category: []
        });
    }

    private static async _registerDataset(subType: string, contextData: IResourceContext): Promise<void> {
        const model = Metamodel.createModel(Dataset.MODEL, {
            name: ModelRegisterationUtils._uniqueModelName(subType, Dataset.MODEL.name),
            abstract: false,
            display: [subType],
            tags: {
                subType,
                type: Dataset.MODEL.name
            },
            createdFromUnknownType: true
        });
        AdapterRegistry.createAdapter({
            model,
            asynchronous: true,
            adapts: {
                name: '*',
                properties: {
                    description: '*',
                    type: '*',
                    structure: '*',
                    linkedServiceName: linkedServiceReferenceWithoutParameterizationRemainer
                }
            }
        }, GenericDatasetAdapter);
        const datasetRegistryService = await getServiceInstance<DatasetRegistryService>(contextData, 'DatasetRegistryService');
        datasetRegistryService.register({
            type: model.name,
            displayName: subType,
            supportLinkedServiceTypes: [],
            notShowInTypeSelection: true, // unknown type shouldn't support create for security reason
            // TODO - ans - Should these be true.
            isSource: true,
            isSink: true,
            datasetKind: 'unknown',
            icon: {
                className: 'svg-i-100x100-PlaceHolderDatabase'
            }
        });
    }

    private static _uniqueModelName(subType: string, type: string): string {
        return `${subType}${ModelFetchUtils.separator}${type}`;
    }
}
